import * as React from 'react';
import ResidentLocationMap from './ResidentLocationMap';

const ResidentLocationContainer = () => (
  <>
    <ResidentLocationMap />
  </>
);
export default ResidentLocationContainer;
